<ftr-animated-remote [remote]="contactDetails" [successTemplate]="success">
  <ng-template #success let-configuration>
    @if (configuration.contactDetails; as contactElevioArticleId) {
      <p class="help__description">
        For your current court, you can find the contact details in
        <a ftrElevioTrigger [articleId]="contactElevioArticleId">this help article</a>.
      </p>
    }
  </ng-template>
</ftr-animated-remote>
